"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BurgerMenu = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
/**
 * @internal
 */
exports.BurgerMenu = function (_a) {
    var color = _a.color, className = _a.className, width = _a.width, height = _a.height;
    return (react_1.default.createElement("svg", { className: className, width: width !== null && width !== void 0 ? width : 16, height: height !== null && height !== void 0 ? height : 16, viewBox: "0 0 16 16", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("g", { transform: "translate(4 3)" },
            react_1.default.createElement("path", { d: "M0 0h8v2H0V0zm0 4h8v2H0V4zm0 4h8v2H0V8z", fill: color !== null && color !== void 0 ? color : "currentColor" }))));
};
//# sourceMappingURL=BurgerMenu.js.map